import { ImportContextFormData } from 'pages/orchestration/rightsQueue/stepDetails/components/stepSpecificViews/ImportContext/interfaces'
import { StepDetailsDTO } from '@ketch-com/figurehead'

export const useImportContextInitialValues = (stepDetails: StepDetailsDTO): ImportContextFormData => {
  const { manualInterventionData = {} } = stepDetails
  const { importContextValue = '' } = manualInterventionData

  return { importContextValue }
}
